import { ColumnTypeEnum } from '@y42/json-schema';
import { DistributionTypes, FormatConfig, TableRendererEnum } from '@y42/model';
import { ColumnState } from 'ag-grid-community';
import { TableConditionalFormattingRule } from '../conditional-formatting.model';
import { fieldId } from '../field-id.model';
import { RichTextStyle } from './sub-models/datos-axis.model';
import { CellTypesSettingsModel } from './sub-models/table-settings.model';

export class TableSettingsModel {
  constructor(
    public series: TableColumnModel[] = [],
    public dimensions: TableColumnModel[] = [],
    public breakdowns: TableColumnModel[] = [],
    public columnState: ColumnState[] = [],
    public groupExpandedKeys: string[] = [],
    public suppressMovable = false,
    public paging = true,
    public sortable = true,
    public resizable = true,
    public showFooterTotal = false,
    public rowSettings: RichTextStyle | undefined = new RichTextStyle(),
    public conditionalFormattingRules?: TableConditionalFormattingRule[],
  ) {}
}

export class TableColumnModel {
  constructor(
    public field_id: fieldId,
    public type: ColumnTypeEnum | null = null,
    public header_name: string | null = null,
    public renderer: TableRendererEnum = TableRendererEnum.Default,
    public cellSettings: RichTextStyle = new RichTextStyle(),
    public cellTypesSettings: CellTypesSettingsModel = {
      barSettings: {
        max: 0,
        displayPercent: false,
        diffColumn: ['none'],
      },
      imageSettings: {
        width: 50,
        height: 50,
      },
      distributionSettings: {
        type: DistributionTypes.Bar,
      },
    },
    public format = 'inherit',
    public showAggregationText = true,
    public showInPercentage = false,
    public formatConfig?: FormatConfig,
    public sort: TableColumnSort = 'asc',
  ) {}
}

export type TableColumnSort = 'asc' | 'desc';
